<template>
	<div>
		<table class="table table-borderless text-center" v-if="reportData">
			<thead >
					<tr>
						<th rowspan="2">Kode Dealer</th>
						<th rowspan="2">Dealer</th>
						<th rowspan="2">Ring</th>
						<!-- <th rowspan="2">Sum % Contr Ring</th> -->
						<th colspan="4">Target</th>
						<th colspan="4">Actual</th>
						<th rowspan="2">Gap</th>
						<th rowspan="2">Deviasi Market<br>(Target Vs Actual)</th>
					</tr>
					<tr>
						<th>Unit</th>
						<th>MS</th>
						<th>TM</th>
						<th>MS Dealer</th>
						<th>Unit</th>
						<th>MS</th>
						<th>TM</th>
						<th>MS Dealer</th>
					</tr>
					
				</thead>
				<tbody v-for="(data, index) in reportData.rows">
					<tr>
						<!-- <td>{{data}}</td> -->
						<td>{{data.kd_dealer}}</td>
						<td>{{data.nama_dealer}}</td>
						<td>{{data.ring}}</td>
						<!-- <td>{{'-'}}</td> -->
						<td>{{data.target_unit}}</td>
						<td>{{data.target_ms}} %</td>
						<td>{{data.target_tm}}</td>
						<td>{{data.target_ms_dealer}} %</td>
						<td>{{data.actual_unit}}</td>
						<td>{{data.actual_ms}} %</td>
						<td>{{data.actual_tm}}</td>
						<td>{{data.actual_ms_dealer}} %</td>
						<td :style="{'color' : isNumeric(data.gap) ? parseFloat(data.gap) > 0 ? 'black' : 'red' : 'black'}">
							{{data.gap ? data.gap : '-'}} 

						</td>
						<td v-if="index == 0">{{reportData.market_deviasi}} %</td>
					</tr>
				</tbody>
		</table>
	</div>
</template>

<script>
const XLSX = require('xlsx')
import moment from 'moment'
export default {
	data () {
		return {
			reportData : null
		}
	},
	props : ['filter'],
	watch : {
		filter : {
			deep : true,
			handler () {
				this.loadApi()
			}
		}
	},
	mounted () {
		this.loadApi()
	},
	methods : {
		isNumeric(value) {
			return !isNaN(value)
		},
		exportExcel () {
			let wb = XLSX.utils.book_new()

			if(this.reportData.rows.length <= 0)
				return
			
			let keys = Object.keys(this.reportData.rows[0])

			let arr = []

			for(var i = 0 ; i < this.reportData.rows.length ; i++) {
				let newObj = {
					'Market Deviation' : ''
				}

				if(i == 0)
					newObj['Market Deviation'] = this.reportData.market_deviasi

				let curObj = this.reportData.rows[i]
				for(var j = 0 ; j < keys.length ; j++) {
					let keyName = this.toCapitalizedWords(keys[j])
					newObj[keyName] = curObj[keys[j]]
				}
				arr.push(newObj)
			}

			let ws1 = XLSX.utils.json_to_sheet(arr, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws1, "MCD Report")


			XLSX.writeFile(wb, 'Kecamatan MCD Target.xlsx')
		},
		loadApi() {
			if(!this.filter.kecamatan) return

			let urlList = [{
				url : '/api/h1/report-mcd/by-area',
				var : 'reportData'
			}]


			for(var i = 0 ; i < urlList.length ; i++) {
				let curList = urlList[i]

				let filterStr = this.initialiseFilter('?' , this.filter)
				this.$http.get(curList.url + filterStr)
				.then((resp) => {
					this[curList.var] = resp.data.data

					// this[curList.var].rows = this[curList.var].rows.map(x => x.gap = '-5.00')
					// for(var i = 0 ; i < this[curList.var].rows.length ; i++) {
					// 	let curData = this[curList.var].rows[i]
					// 	curData.gap = '-5.00'
					// }
				})
				.catch((err) => {
					console.log(err)
				})
			}
		}
	}
}
</script>